'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('eb_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('eb_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('eb_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-50 animate-fade-in"
    >
      <div className="bg-white border border-[rgba(27,67,50,0.12)] rounded-2xl shadow-lg p-5">
        <p className="text-sm text-[#0D1F17] font-medium mb-1" style={{ fontFamily: 'var(--font-body)' }}>
          We use cookies 🍪
        </p>
        <p className="text-xs text-[#6B7C74] leading-relaxed mb-4" style={{ fontFamily: 'var(--font-body)' }}>
          We use cookies to improve your experience and analyze site usage. See our{' '}
          <Link href="/privacy-policy" className="text-[#1B4332] underline underline-offset-2 hover:text-[#52B788] transition-colors">
            Privacy Policy
          </Link>{' '}
          for details.
        </p>
        <div className="flex gap-2">
          <button
            onClick={handleAccept}
            className="flex-1 bg-[#1B4332] text-white text-xs font-semibold py-2 px-4 rounded-lg hover:bg-[#0D2B1F] transition-colors"
            style={{ fontFamily: 'var(--font-body)' }}
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-transparent text-[#6B7C74] text-xs font-semibold py-2 px-4 rounded-lg border border-[rgba(27,67,50,0.12)] hover:border-[#1B4332] hover:text-[#1B4332] transition-colors"
            style={{ fontFamily: 'var(--font-body)' }}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
